export const BASE_URL = '/profile/'
